// region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Routes
//
//  Copyright:    © 2025 - 2026 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
// region Version 1.0.0.0
//    001   20.02.25 Sean Flook          GMSCM-1 Initial Revision.
//    002   05.02.26 Sean Flook         GMSCM-12 Added Application and Organisation functionality.
//    003   10.03.26 Joshua McCormick    GMSCM-14 Route changes
// endregion Version 1.0.0.0
//
//--------------------------------------------------------------------------------------------------
// endregion header

import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from "./pages/Layout";
import DocumentsPage from "./pages/DocumentsPage";
import ClusterPage from "./pages/ClusterPage";
import ApplicationPage from "./pages/ApplicationPage";
import ErrorPage from "./pages/ErrorPage";
import OrganisationPage from "./pages/OrganisationPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Navigate to="/documents" replace /> },
      { path: "documents", element: <DocumentsPage /> },
      { path: "clusters", element: <ClusterPage /> },
      { path: "applications", element: <ApplicationPage /> },
      { path: "organisations", element: <OrganisationPage /> },
    ],
  },
]);

export default router;
